import { publish } from '@core/constants/customEvents';
import { ButtonFactory } from './buttonRegistryFactory';

const createDoubleSignatureRibbonButton: ButtonFactory = () => {
  return {
    key: 'buttonDoubleSignature',
    unlocalizedText: 'Insert Double Signature',
    iconName: 'DoubleColumnEdit',
    onClick: async () => {
      publish('evodicom.report.insertDoubleSignature', undefined);
    },
  };
};

export default createDoubleSignatureRibbonButton;
